/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const ImportExportAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const ImportExportBooleanOperator = {
    IS_TRUE: "IS_TRUE",
    IS_FALSE: "IS_FALSE",
};
export const ImportExportExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const ImportExportIOJobStatus = {
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    DONE: "DONE",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
    INCOMPATIBLE_FORMAT: "INCOMPATIBLE_FORMAT",
    KILLED: "KILLED",
};
export const ImportExportIOJobType = {
    IMPORT: "IMPORT",
    EXPORT: "EXPORT",
    CLASS_IMPORT: "CLASS_IMPORT",
    CLASS_EXPORT: "CLASS_EXPORT",
    DATA_EXCHANGE: "DATA_EXCHANGE",
};
export const ImportExportManifestSelection = {
    JOBS: "JOBS",
    DEPLOYMENTS: "DEPLOYMENTS",
    DATAPOOL_RECORDS: "DATAPOOL_RECORDS",
};
export const ImportExportNumberOperator = {
    IS_EQUAL_TO: "IS_EQUAL_TO",
    IS_NOT_EQUAL_TO: "IS_NOT_EQUAL_TO",
    IS_GREATER_THAN: "IS_GREATER_THAN",
    IS_GREATER_THAN_OR_EQUAL_TO: "IS_GREATER_THAN_OR_EQUAL_TO",
    IS_LESS_THAN: "IS_LESS_THAN",
    IS_LESS_THAN_OR_EQUAL_TO: "IS_LESS_THAN_OR_EQUAL_TO",
};
export const ImportExportRecordImportMode = {
    SAMPLE: "SAMPLE",
    EXAMPLE: "EXAMPLE",
    ANY: "ANY",
};
export const ImportExportRecordLoadMode = {
    SAMPLE: "SAMPLE",
    EXAMPLE: "EXAMPLE",
    ANY: "ANY",
};
export const ImportExportTargetPlatformType = {
    LOCAL: "LOCAL",
    REMOTE: "REMOTE",
};
export const ImportExportTextOperator = {
    CONTAINS: "CONTAINS",
    DOES_NOT_CONTAIN: "DOES_NOT_CONTAIN",
    STARTS_WITH: "STARTS_WITH",
    IS_EXACTLY: "IS_EXACTLY",
    IS_EMPTY: "IS_EMPTY",
    IS_NOT_EMPTY: "IS_NOT_EMPTY",
};
export const ImportExportTimestampOperator = {
    IS_ON: "IS_ON",
    IS_BEFORE: "IS_BEFORE",
    IS_AFTER: "IS_AFTER",
    IS_BETWEEN: "IS_BETWEEN",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Import Export Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    dataExchange = {
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags data_exchange
         * @name GetExportSteps
         * @summary Get Export Steps
         * @request POST:/data-exchange/export-steps
         * @secure
         */
        getExportSteps: (data, params = {}) => this.request({
            path: `/data-exchange/export-steps`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags data_exchange
         * @name GetImportSteps
         * @summary Get Import Steps
         * @request POST:/data-exchange/import-steps
         * @secure
         */
        getImportSteps: (data, params = {}) => this.request({
            path: `/data-exchange/import-steps`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Update tag metadata with summary attributes extracted from imported records. This endpoint reads sample records tagged with the given tag, extracts summary attributes (like image views for multi-view data), and updates the tag metadata. **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags data_exchange
         * @name UpdateTagSummaryAttributes
         * @summary Update Tag Summary Attributes
         * @request POST:/data-exchange/update-tag-summary-attributes
         * @secure
         */
        updateTagSummaryAttributes: (query, params = {}) => this.request({
            path: `/data-exchange/update-tag-summary-attributes`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    imports = {
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags imports
         * @name ListImportJobs
         * @summary List Import Jobs
         * @request GET:/imports
         * @secure
         */
        listImportJobs: (query, params = {}) => this.request({
            path: `/imports`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags imports
         * @name StartImportJob
         * @summary Start Import Job
         * @request POST:/imports
         * @secure
         */
        startImportJob: (data, params = {}) => this.request({
            path: `/imports`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags imports
         * @name GetImportJobCreationUpdates
         * @summary Get Import Job Creation Updates
         * @request GET:/imports/-/creation
         * @secure
         */
        getImportJobCreationUpdates: (params = {}) => this.request({
            path: `/imports/-/creation`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags imports
         * @name ListImportFields
         * @summary List Import Fields
         * @request GET:/imports/fields
         * @secure
         */
        listImportFields: (params = {}) => this.request({
            path: `/imports/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags imports
         * @name DeleteImportJob
         * @summary Delete Import Job
         * @request DELETE:/imports/{job_id}
         * @secure
         */
        deleteImportJob: (jobId, params = {}) => this.request({
            path: `/imports/${jobId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags imports
         * @name GetImportJob
         * @summary Get Import Job
         * @request GET:/imports/{job_id}
         * @secure
         */
        getImportJob: (jobId, params = {}) => this.request({
            path: `/imports/${jobId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags imports
         * @name StopImportJob
         * @summary Stop Import Job
         * @request POST:/imports/{job_id}/stop
         * @secure
         */
        stopImportJob: (jobId, query, params = {}) => this.request({
            path: `/imports/${jobId}/stop`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags imports
         * @name GetImportUpdates
         * @summary Get Import Updates
         * @request GET:/imports/{job_id}/updates
         * @secure
         */
        getImportUpdates: (jobId, params = {}) => this.request({
            path: `/imports/${jobId}/updates`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    jobs = {
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags jobs
         * @name ListIoJobs
         * @summary List Io Jobs
         * @request GET:/jobs
         * @secure
         */
        listIoJobs: (query, params = {}) => this.request({
            path: `/jobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags jobs
         * @name StartIoJob
         * @summary Start Io Job
         * @request POST:/jobs
         * @secure
         */
        startIoJob: (data, params = {}) => this.request({
            path: `/jobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags jobs
         * @name GetIoJobCreationUpdates
         * @summary Get Io Job Creation Updates
         * @request GET:/jobs/-/creation
         * @secure
         */
        getIoJobCreationUpdates: (params = {}) => this.request({
            path: `/jobs/-/creation`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags jobs
         * @name ListIoJobFields
         * @summary List Io Job Fields
         * @request GET:/jobs/fields
         * @secure
         */
        listIoJobFields: (params = {}) => this.request({
            path: `/jobs/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags jobs
         * @name DeleteIoJob
         * @summary Delete Io Job
         * @request DELETE:/jobs/{job_id}
         * @secure
         */
        deleteIoJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags jobs
         * @name GetIoJob
         * @summary Get Io Job
         * @request GET:/jobs/{job_id}
         * @secure
         */
        getIoJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD
         *
         * @tags jobs
         * @name StopIoJob
         * @summary Stop Io Job
         * @request POST:/jobs/{job_id}/stop
         * @secure
         */
        stopIoJob: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/stop`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags jobs
         * @name GetIoJobUpdates
         * @summary Get Io Job Updates
         * @request GET:/jobs/{job_id}/updates
         * @secure
         */
        getIoJobUpdates: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/updates`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetMetrics
         * @summary Get Metrics
         * @request GET:/prometheus
         * @secure
         */
        getMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    version = {
        /**
         * @description Get application version.
         *
         * @tags monitor
         * @name GetVersion
         * @summary Get Version
         * @request GET:/version
         * @secure
         */
        getVersion: (params = {}) => this.request({
            path: `/version`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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